import {
  NEW_BUTTON_SELECTION_DIALOG,
  SET_CONTENT,
  SHOW_DIALOG,
  SET_RESOLVE,
  RESET_STATE
} from "./constants.js";

const regex = /^(buttonSelectionDialog\/)/;

const _NEW_BUTTON_SELECTION_DIALOG = NEW_BUTTON_SELECTION_DIALOG.replace(
  regex,
  ""
);

export default {
  async [_NEW_BUTTON_SELECTION_DIALOG](
    { commit },
    {
      title,
      text = null,
      cancelText = "Cancel",
      onSelection = () => {},
      onCancel = () => {},
      maxWidth = null,
      selection = [],
      hasFilter = false,
      icon = null,
      layer = 0
    }
  ) {
    commit(SET_CONTENT, {
      title,
      text,
      cancelText,
      onSelection,
      onCancel,
      maxWidth,
      selection,
      hasFilter,
      icon,
      layer
    });
    const promise = new Promise(resolve => {
      commit(SET_RESOLVE, resolve);
    });
    commit(SHOW_DIALOG, true);
    const result = await promise;
    commit(RESET_STATE);
    return result;
  }
};
